import { create } from "zustand";
import {
  activateUser,
  createNewUser,
  deactivateUser,
  editSSOT,
  editUser,
  fetchUser,
  fetchUserV1,
  getAssingedCases,
  getAuditLog,
  getFreshworkDetails,
  getLoginReport,
  getRoles,
  getUserSearch,
  setActivityLog,
  setStatus,
  updateUser,
  getSSOTFilter,
  getSSOTFilterApply,
  getQaAgents,
  getCallProvider,
  getUsersCallProvider,
  updateUserCallProvider,
  createUserCallProvider,
  updateCallProvider,
  createCallProvider,
  reallocateUser,
} from "../api";
import { toast } from "react-toastify";
import { ERROR_MESSAGES } from "modules/utilities/utility";
import { get } from "lodash";
import secureLocalStorage from "react-secure-storage";
export const useUserInfo = create((set) => ({
  userData: [],
  userDataV1: { result: [], total: 0 },
  isLoading: false,
  isError: false,
  errorMessage: "",
  fetchUserData: async (role) => {
    try {
      set({ isLoading: true, error: null });
      const response = await fetchUser(role);
      set({ userData: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.message });
    } finally {
      set({ isLoading: false });
    }
  },
  fetchUserDataV1: async (userId) => {
    try {
      set({ isLoading: true, error: null });
      const response = await fetchUserV1();
      set({ userDataV1: response.data });
    } catch (error) {
      set({ error: error.message });
    } finally {
      set({ isLoading: false });
    }
  },
  fetchEditSSOT: async (payload) => {
    try {
      set({ isLoading: true, error: null });
      await editSSOT(payload);
      toast.success("Updated Successfully");
    } catch (error) {
      set({ error: error?.message });
      toast.error(`Error: ${error?.response?.data?.message}`);
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const useSetSatus = create((set) => ({
  statusData: {},
  isLoading: false,
  isError: false,
  errorMessage: "",
  setUserStatus: async (status, id) => {
    try {
      set({ isLoading: true, error: null });
      const response = await setStatus(status, id);
      set({ statusData: response.data });
    } catch (error) {
      console.error(error);
      set({ error: error?.message });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const createUser = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  createUserStatus: async (payload, setToaster) => {
    try {
      set({ isLoading: true, error: null });
      const response = await createNewUser(payload);
      setToaster("Create User", "Successful", "success");
      const auditLog = {
        authorName: secureLocalStorage.getItem("first_name"),
        original: {
          user: payload.user,
          role: {
            id: payload.role
          }
        },
        modified: {...payload.user, isNewUser: true},
      }
      await setActivityLog(response.data.id, auditLog);
    } catch (error) {
      setToaster("Create User", error?.response.data.message, "danger");
      console.error(error);
      set({ error: error?.message });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const userRoles = create((set) => ({
  roleData: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  getUserRoles: async () => {
    try {
      set({ isLoading: true, error: null });
      const response = await getRoles();
      set({ roleData: response.data });
    } catch (error) {
      console.error(error);
      set({ error: error?.message });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const auditLog = create((set) => ({
  auditData: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  getAudtiLogs: async (userid) => {
    try {
      set({ isLoading: true, error: null });
      const response = await getAuditLog(userid);
      set({ auditData: response.data });
    } catch (error) {
      console.error(error);
      set({ error: error?.message });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const updateUsers = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  userUpdate: async (
    userid,
    payload,
    setToaster,
    fetchUserData,
    currentUser,
    isToday
  ) => {
    try {
      set({ isLoading: true, error: null });
      await updateUser(userid, payload, isToday);
      setToaster("Edit User", "User has been edited succesfuly", "success");
      fetchUserData(currentUser);
    } catch (error) {
      setToaster("Edit User", error?.response.data.message, "danger");
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const acivityLog = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  activityLogs: async (userId, payload) => {
    try {
      set({ isLoading: true, error: null });
      const response = await setActivityLog(userId, payload);

      set({ editData: response.data });
    } catch (error) {
      set({ error: error?.response.data.Error });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const freshworkDetails = create((set) => ({
  freshworkDetailsData: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  freshworkData: async (userId) => {
    try {
      set({ isLoading: true, error: null });
      const response = await getFreshworkDetails(userId);
      set({ freshworkDetailsData: response.data, isLoading: false });
    } catch (error) {
      set({ error: error?.response.data.Error });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const deactivateUsers = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  reallocateUserFunc: async (
    userId,
    setToaster
  ) => {
    try {
      set({ isLoading: true, error: null });
      await reallocateUser(userId);
      setToaster("Reallocate User", "User Reallocated Successfully", "success");
      // set({ editData: response.data });
    } catch (error) {
      set({ error: error?.response.data.Error });
    } finally {
      set({ isLoading: false });
    }
  },
  deactivateCurrentUser: async (
    userId,
    setToaster,
    fetchUserData,
    currentUser
  ) => {
    try {
      set({ isLoading: true, error: null });
      const response = await deactivateUser(userId, setToaster);
      setToaster("Deactivate User", "User Deactivated Successfully", "success");
      fetchUserData(createUser);
      set({ editData: response.data });
    } catch (error) {
      setToaster("Deactivate User", error?.response.data.message, "danger");
      set({ error: error?.response.data.Error });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const updateFreshworkDetails = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  setFreshworkDetails: async (userId, payload) => {
    try {
      set({ isLoading: true, error: null });
      const response = await updateFreshworkDetail(userId, payload);
      set({ editData: response.data });
    } catch (error) {
      set({ error: error?.response.data.Error });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const getUserFromSearch = create((set) => ({
  searchResult: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  getSearchUser: async (searchQuery, currentUser) => {
    try {
      set({ isLoading: true, error: null });
      const response = await getUserSearch(searchQuery, currentUser);
      set({ searchResult: response.data });
    } catch (error) {
      set({ error: error?.response.data.Error });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const editUsers = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "Error in editing the user",
  editCurrentUser: async (userId, payload, setToaster) => {
    try {
      set({ isLoading: true, error: null });
      const response = await editUser(userId, payload);
      setToaster("Edit User", "Successful", "success");
      set({ editData: response.data });
    } catch (error) {
      setToaster("Edit User", "Request Failed", "danger");
      set({ error: error?.message });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const loginReport = create((set) => ({
  loginReportResult: [],
  isLoading: false,
  isError: false,
  errorMessage: "Error in editing the user",
  getLoginReport: async (startDate, endDate) => {
    try {
      set({ isLoading: true, error: null });
      const response = await getLoginReport(startDate, endDate);
      set({ loginReportResult: response.data });
    } catch (error) {
      set({ error: error?.message });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const assignedCases = create((set) => ({
  casesData: {},
  isLoading: false,
  isError: false,
  errorMessage: "",
  fetchassingnedCaseDetails: async (role) => {
    try {
      set({ isLoading: true, error: null });
      const response = await getAssingedCases(role);
      set({ casesData: response.data });
    } catch (error) {
      set({ error: error.message });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const activateUsers = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  activateCurrentUser: async (
    userId,
    setToaster,
    fetchUserData,
    currentUser
  ) => {
    try {
      set({ isLoading: true, error: null });
      const response = await activateUser(userId);
      setToaster("Deactivate User", "user activated Successfully", "success");
      fetchUserData(currentUser);
      set({ editData: response.data });
    } catch (error) {
      setToaster("Deactivate User", error?.response.data.message, "danger");
      set({ error: error?.response.data.Error });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const useSSOTFilterData = create((set) => ({
  newFiltersData: [],
  newFiltersLoading: false,
  newFiltersError: null,
  fetchSSOTFilters: async () => {
    try {
      set({ newFiltersLoading: true, newFiltersError: null });
      const response = await getSSOTFilter();
      set({ newFiltersData: response.data });
    } catch (error) {
      set({ newFiltersError: error.message });
      toast.error(error.message);
    } finally {
      set({ newFiltersLoading: false });
    }
  },
}));
export const useSSOTFilterApply = create((set) => ({
  qaAgentsResponse: [],
  qaAgentsError: null,
  qaAgentsLoading: false,
  newFiltersApplyData: { result: [], total: 0 },
  newFiltersApplyLoading: false,
  newFiltersApplyError: null,
  fetchSSOTFiltersApply: async (params) => {
    try {
      set({ newFiltersApplyLoading: true, newFiltersApplyError: null });
      const response = await getSSOTFilterApply(params);
      set({ newFiltersApplyData: response.data });
    } catch (error) {
      set({ newFiltersApplyError: error.message });
      toast.error(error.message);
    } finally {
      set({ newFiltersApplyLoading: false });
    }
  },
  getQaAgentsList: async () => {
    try {
      set({ qaAgentsLoading: true, qaAgentsError: null, qaAgentsResponse: [] });
      const response = await getQaAgents();
      const data = await response?.data;
      set({ qaAgentsResponse: data, qaAgentsLoading: false });
    } catch (error) {
      set({
        qaAgentsLoading: false,
        qaAgentsError: error,
        qaAgentsResponse: [],
      });
      toast.error(get(error, ["message"], "Something went wrong"));
    }
  },
}));

export const useCallProviderStore = create((set, get) => ({
  isCallProviderLoading: false,
  isUserCallProviderLoading: false,
  updateUserProviderLoading: false,
  createUserProviderLoading: false,
  updateProviderLoading: false,
  createProviderLoading: false,
  error: null,
  callProvidersResponse: [],
  userCallProvidersResponse: {},
  fetchCallProvider: async () => {
    try {
      set({ isCallProviderLoading: true });
      const response = await getCallProvider();
      const data = await response?.data;
      if (data?.status) {
        set({ callProvidersResponse: data });
      }
    } catch (error) {
      toast.error(_.get(error, ["message"], ERROR_MESSAGES.SWW));
    } finally {
      set({ isCallProviderLoading: false });
    }
  },
  fetchUserCallProvider: async (query) => {
    try {
      set({ isUserCallProviderLoading: true });
      const response = await getUsersCallProvider(query);
      const data = await response?.data;
      if (data?.status) {
        set({ userCallProvidersResponse: data });
      }
    } catch (error) {
      toast.error(_.get(error, ["message"], ERROR_MESSAGES.SWW));
    } finally {
      set({ isUserCallProviderLoading: false });
    }
  },
  updateUserCallProviderHandler: async (userCallProviderId, payload) => {
    try {
      set({ updateUserProviderLoading: true });
      const response = await updateUserCallProvider(
        userCallProviderId,
        payload
      );
      const data = await response?.data;
      if (data?.status) {
        toast.success(_.get(data, ["message"]));
      }
    } catch (error) {
      toast.error(
        _.get(
          error,
          ["response", "data", "message"],
          _.get(error, ["message"], ERROR_MESSAGES.SWW)
        )
      );
    } finally {
      set({ updateUserProviderLoading: false });
    }
  },
  createUserCallProvider: async (payload) => {
    try {
      set({ createUserProviderLoading: true });
      const response = await createUserCallProvider(payload);
      const data = await response?.data;
      if (data?.status) {
        toast.success(_.get(data, ["message"]));
      }
    } catch (error) {
      toast.error(
        _.get(
          error,
          ["response", "data", "message"],
          _.get(error, ["message"], ERROR_MESSAGES.SWW)
        )
      );
    } finally {
      set({ createUserProviderLoading: false });
    }
  },
  updateCallProviderHandler: async (providerId, payload) => {
    try {
      set({ updateProviderLoading: true });
      const response = await updateCallProvider(providerId, payload);
      const data = await response?.data;
      if (data?.status) {
        toast.success(_.get(data, ["message"]));
      }
    } catch (error) {
      toast.error(
        _.get(
          error,
          ["response", "data", "message"],
          _.get(error, ["message"], ERROR_MESSAGES.SWW)
        )
      );
    } finally {
      set({ updateProviderLoading: false });
    }
  },
  createCallProviderHandler: async (payload) => {
    try {
      set({ createProviderLoading: true });
      const response = await createCallProvider(payload);
      const data = await response?.data;
      if (data?.status) {
        toast.success(_.get(data, ["message"]));
      }
    } catch (error) {
      toast.error(
        _.get(
          error,
          ["response", "data", "message"],
          _.get(error, ["message"], ERROR_MESSAGES.SWW)
        )
      );
    } finally {
      set({ createProviderLoading: false });
    }
  },
}));
